import { render, staticRenderFns } from "./CompKindChip.vue?vue&type=template&id=4fb7c436&functional=true"
import script from "./CompKindChip.vue?vue&type=script&lang=js"
export * from "./CompKindChip.vue?vue&type=script&lang=js"
import style0 from "./CompKindChip.vue?vue&type=style&index=0&id=4fb7c436&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports